export const FILTER_CATEGORIES = ["tags", "authors"];

export const SOCKIT_VERSION_NUMBER = '0.2.1'